module.exports = __webpack_public_path__ + "static/media/SUMMARY_0013_01.040f1eec.webp";